export { default as fetch } from 'cross-fetch';
export const fetchOptions = {};
